module.exports = __webpack_public_path__ + "static/media/password-lock-12.1e21bdbb.svg";